let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fviv5")).then(() => parcelRequire('d1j2S'));